import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import { SvgIcon } from '../../SvgIcon';
import { renderEcalSyncButtons } from 'common/react/utils/ecal-react';

export const CalendarButton = ({
    ecalId,
    calendarLinkUrl,
    calendarLinkText,
    calendarLinkIcon
}) => {
    useEffect(() => {
        renderEcalSyncButtons(window.ecalApiKey);
    }, []);

    const isLinkExternal = PULSE.app.common.url.isExternalUrl(calendarLinkUrl);

    return calendarLinkUrl ? (
        <a
            href={calendarLinkUrl}
            className="competition-nav__button ecal-sync-widget-button"
            data-ecal-no-styling
            target={isLinkExternal && '_blank'}
            rel={isLinkExternal && 'noopener noreferrer'}
        >
            <SvgIcon icon={calendarLinkIcon} className="icon" />
            <span>{calendarLinkText}</span>
        </a>
    ) : (
        <button
            className="competition-nav__button ecal-sync-widget-button"
            data-ecal-widget-id={ecalId}
            data-ecal-no-styling
        >
            <SvgIcon icon={calendarLinkIcon} className="icon" />
            <span>{calendarLinkText}</span>
        </button>
    );
};

CalendarButton.propTypes = {
    ecalId: PropTypes.string,
    calendarLinkUrl: PropTypes.string,
    calendarLinkText: PropTypes.string.isRequired,
    calendarLinkIcon: PropTypes.string.isRequired
};
